export interface CrmStorageFileUploadResponseDto {
  path: string;
  url: string;
  type: string | null;
}
